
function viewport() {
    var e = window, a = 'inner';
    if (!('innerWidth' in window)) {
        a = 'client';
        e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
}

export function FindElById(elementId) {
    if (document.getElementById('CtlquickSearch1_ddlDays')) {
        elementId = 'CtlquickSearch1_' + elementId;
    }
    if (document.getElementById(elementId)) {
        return document.getElementById(elementId);
    }
    else if ($("[id$='_" + elementId + "']").length) {
        return $("[id$='_" + elementId + "']")[0];
    }
    else {
        return null;
    }
}

function FindElsByName(name) {
    var match = $("[name$=':" + name + "']");
    if (match.length > 0) {
        return document.getElementsByName(match.attr('name'));
    }
    return null;
}


/** Polyfill for indexOf in IE **/
if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function (searchElement /*, fromIndex */) {
        "use strict";
        if (this == null) {
            throw new TypeError();
        }
        var t = Object(this);
        var len = t.length >>> 0;
        if (len === 0) {
            return -1;
        }
        var n = 0;
        if (arguments.length > 0) {
            n = Number(arguments[1]);
            if (n != n) { // shortcut for verifying if it's NaN
                n = 0;
            } else if (n != 0 && n != Infinity && n != -Infinity) {
                n = (n > 0 || -1) * Math.floor(Math.abs(n));
            }
        }
        if (n >= len) {
            return -1;
        }
        var k = n >= 0 ? n : Math.max(len - Math.abs(n), 0);
        for (; k < len; k++) {
            if (k in t && t[k] === searchElement) {
                return k;
            }
        }
        return -1;
    };
}

var recaptcha = {};
recaptcha.q = 0;
recaptcha.load = function (elementId, responseCallback) {
    var renderCallback = function () {
        var widgetId = grecaptcha.render(elementId, {
            sitekey: '6LclUq4UAAAAADvCTHkIsEtgWhj3RPpliprEHjTc',
            callback: responseCallback
        });
        jQuery('#' + elementId).attr('data-widgetid', widgetId);
    };

    if (typeof grecaptcha === 'undefined') {
        // google recaptcha script not loaded yet, register the render callback and load the script
        var callbackName = 'recaptchaCBQ_' + (recaptcha.q += 1);
        window[callbackName] = renderCallback;
        var script = document.createElement('script');
        script.src = 'https://www.google.com/recaptcha/api.js?onload=' + callbackName + '&render=explicit';
        document.head.appendChild(script);
    } else {
        // script already loaded, render the recaptcha straight away
        renderCallback();
    }
};
recaptcha.reset = function (elementId) {
    var widgetId = jQuery('#' + elementId).attr('data-widgetid');
    if (typeof widgetId !== 'undefined') {
        grecaptcha.reset(widgetId);
    }
}

$(function () {
    $('.AccessOrCreate .show-password').click(function (e) {
        var passwordBox = $(e.target).prev('input');
        if (passwordBox.attr('type') === 'text') {
            passwordBox.attr('type', 'password');
            $(e.target).removeClass('hide');
        } else {
            passwordBox.attr('type', 'text');
            $(e.target).addClass('hide');
        }
    });

    $('.AccessOrCreate input[type=submit]').click(function (e) {
        var passwordinputs = document.getElementsByClassName('password');
        for (let i = 0; i < passwordinputs.length; i += 1) {
            passwordinputs[i].type = 'password';
        }
    });

    $('.handle').click(function (e) {
        e.preventDefault();
    });

    //Added below https://trello.com/c/J6oYeOCz
    $('#helper:empty').hide();

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //HELP HOVERS
    $('.question').live({
        'mouseover': function () {
            var helptext = $(this).attr('rel');

            switch (helptext) {
                // case 'ccv':                                
                // 	var content = '<img src="/images/icon-ccv-security.png" width="" height="" /><p>The last 3 digits of your signature strip';                                
                // break;                                
                case 'booking-fee':
                    var content = 'A non-refundable booking fee of £40 is payable per booking of which 10% is donated to our supported charities; Shelter Box & Macmillan Cancer. If two or more properties are booked these constitute as separate bookings and are subject to separate bookings fees.'; break;
                // case 'surcharge':                                
                // 	var content = '';                                
                // break;                                
                case 'Dogs':
                    var content = 'Dogs are welcome in your chosen property and are charged at £38 each per Dog per week.';
                    break;
                case 'Cancellation Insurance':
                    var content = 'We strongly recommend that you take out cancellation insurance. Please tick this box to receive details from our preferred insurers.';
                    break;
                case 'Cot/Linen/Towel Hire':
                    var content = 'Please tick the box if you would like to receive information on hiring linen, cots and extra towels.';
                    break;
                case 'luxury-hamper':
                    var content = 'Why not treat yourselves to one of our luxury hampers which will be waiting for you when you arrive at your property. All products are locally sourced from our supplier Trevaskis Farm and will include handemade choclates and biscuits, freshly squeezed juices and a bottle of bubbly from Polgoon Vineyard. *Items may change seasonally.';
                    break;
                case 'cottagePets':
                    var content = 'Dogs are &pound;38 per dog per week to cover the extra cost of housekeeping';

                    break;
                case 'deposit':
                    var content = 'Your deposit payment is a third of your total rental. Your final balance will need to be paid 8 weeks before your arrival date. You can log in to your account at any time to pay the remainder of your balance.';
                    break;
                case 'special-price':
                    var content = 'Original price: &pound;' + $(this).attr('data-price-was');
                    $('#helper').addClass('special-price');
                    break;
            }

            var $helper = $('#helper').empty().html(content);


            var top = $(this).offset().top;
            var left = $(this).offset().left + $(this).outerWidth(true);

            $helper.css({ left: left, top: top }).fadeTo(400, 1);


            $(this).mousemove(function (e) {
                $('#helper').css({
                    top: e.pageY + -15,
                    left: e.pageX + 8
                });
            });

        }, 'mouseout': function () {
            var $helper = $('#helper');
            $helper.dequeue().hide();
        }

    });

    ////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    //AJAX IN FORMS

    $('.login-now').click(function (event) {
        event.preventDefault();
        xhr('login');

        $('#frm-login').attr('action', $(this).attr('href'));
    });

    //REQUEST BROCHURE
    $('#brochure-request a').click(function (event) {
        event.preventDefault();
        xhr('request');
    });

    //EMAIL SEARCH RESULTS
    $('a.email-property-list').live('click', function (event) {
        event.preventDefault();
        xhr('email');
    });

    //EMAIL SEARCH RESULTS
    $('a.email-property').click(function (event) {
        event.preventDefault();

        $(this).attr('rel', window.location);

        xhr('email-property');
    });

    //REQUEST BOOKING FORM
    $('#download-booking').click(function (event) {
        event.preventDefault();
        xhr('booking');
    });

    //REQUEST OWNERS BROCHURE
    $('#download-guide, #download a').click(function (event) {
        event.preventDefault();
        xhr('property-owners');
    });

    //PRINT PAGE
    $('.print').live('click', function (e) {
        e.preventDefault();
        window.print();
    });

    //leave a testimonial
    $('a#add-testimonial').click(function (event) {
        event.preventDefault();

        var url = $(this).attr('data-url');

        trackModalView(url); // Analytics tracking

        data = {};

        $.ajax({
            url: url,
            data: data,
            async: false,
            success: function (data) {
                modalWindow(data);

                $('input[type=date], input.date').addClass('datePicker').datepicker({
                    dateFormat: 'yy-mm-dd',
                    firstDay: 1
                });
            }
        });
    });

    $('body.checkout #frm-login').live('submit', function (event) {
        event.preventDefault();
        url = '/ajax/login';

        var $form = $(this);

        data = $(this).serialize();

        $.ajax({
            url: url,
            data: data,
            async: false,
            type: 'POST',
            success: function (data) {
                if (data.success) {
                    $.each(data.identity, function (key, value) {
                        $('#' + key).val(value);
                        if ($('#contact_' + key).length > 0) {
                            $('#contact_' + key).val(value);
                        }
                    });

                    $('#verify_email').val(data.identity.email);

                    $('#overlay-container').remove();
                    $('html').removeClass('logging-in');
                    $('#login-newsletter-search .login, div.sign-in.right').hide();
                } else {
                    $form.find('h3').append('<p style="color:#8B343C;">Sorry there was any error please try again.</p>')
                }
            }
        });
    });

    //GET FORMS
    function xhr(geturl, callback) {
        trackModalView(geturl); // Analytics tracking
        $.ajax({
            url: '/ajax/' + geturl + '.html?v=1',
            async: false,
            success: function (data) {
                modalWindow(data);
                if (typeof (callback) == 'function') callback();
            }
        });
    }

    //AJAX
    $('#frm-email-results, #frm-email-property').live('submit', function (event) {
        event.preventDefault();

        postUrl = $(this).attr('action');

        var arr = new Array();

        $('input.email').each(function () {
            arr.push($(this).val());
        });

        if ($('a.share-url').attr('rel') != '') {
            shareUrl = $('a.share-url').attr('rel');
        } else {
            shareUrl = window.location.href;
        }

        data = {
            data: arr,
            shareUrl: shareUrl
        };

        $.ajax({
            url: postUrl,
            type: 'POST',
            data: data,
            dataType: 'json',
            success: function (data) {
                $('.error').remove();

                if (data.error) {
                    if (data.invalidEmails.length > 0) {
                        var invalidList = '';
                        $.each(data.invalidEmails, function (index, value) {
                            invalidList += value + ', ';
                        });
                        $('.modal-form h3')
                            .after('<p class="error">A number of the emails you entered were invalid: ' + invalidList + ' please check and try these addresses again.</p>');
                    } else {
                        $('.modal-form h3')
                            .after('<p class="error">' + data.error + '</p>');
                    }

                } else {
                    $('.modal-form div').hide();
                    $('.modal-form h3')
                        .empty()
                        .text('Thank you, your emails have been sent.');
                }
            }
        });
    });

    //AJAX SUBMIT TESTIMONIAL
    $('#frm-testimonial').live('submit', function (event) {
        event.preventDefault();
        var modalType = getModalType();

        $('#frm-testimonial div.form').hide().after('<div class="spinny-wrapper"><img src="/images/ajax-loader.gif" /></div>');

        var data = $(this).serialize();

        $.ajax({
            url: $(this).attr('action') + '?format=json',
            type: 'POST',
            data: data,
            dataType: 'json',
            success: function (data) {

                $('.error').remove();

                if (data.error) {
                    $('.spinny-wrapper').remove();
                    $('#frm-testimonial div.form').show()
                    $('#frm-testimonial h3').after('<p class="error">There was a problem with your information. Please check and try again.</p>');
                    $('#captcha-element img').attr('src', data.captcha.src);
                    $('#captcha-element input[name="captcha_guid"]').val(data.captcha.guid);
                } else {
                    $('.spinny-wrapper').remove();
                    $('#frm-testimonial h3')
                        .empty().text('Thank you for your comments, they will be moderated before appearing on this page.');
                    trackModalSuccess(modalType);
                }

            }
        });
    });
    //AJAX REQUEST BROCHURE
    $('#frm-request-brochure').live('submit', function (event) {
        event.preventDefault();
        var modalType = getModalType();
        $('#frm-request-brochure div').hide().after('<div class="spinny-wrapper"><img src="/images/ajax-loader.gif" /></div>');

        arr = $(this).serialize();

        data = {
            data: arr
        };

        $.ajax({
            url: $(this).attr('action'),
            type: 'POST',
            data: data,
            dataType: 'json',
            success: function (data) {
                $('.error').remove();

                if (data.error) {
                    $('.spinny-wrapper').remove();
                    $('#frm-request-brochure div').show()
                    $('#frm-request-brochure h3').after('<p class="error">There was a problem with your information. Please check and try again.</p>');
                } else {
                    $('.spinny-wrapper').remove();
                    $('#frm-request-brochure h3')
                        .empty().text('Thank you, we will send a brochure out to you as soon as possible.');
                    trackModalSuccess(modalType);
                }
            }
        });
    });

    //AJAX REQUEST OWNERS
    $('#frm-request-owners').live('submit', function (event) {
        event.preventDefault();

        arr = $(this).serialize();

        data = {
            data: arr
        };

        $.ajax({
            url: '/ajax/request-owners',
            type: 'POST',
            data: data,
            dataType: 'json',
            success: function (data) {
                $('.error').remove();

                if (data.error) {
                    $('#frm-request-owners h3').after('<p class="error">There was a problem with your information. Please check and try again.</p>');
                } else {
                    $('#frm-request-owners div').hide();
                    $('#frm-request-owners h3')
                        .empty().text('Thank you, please download the brochure using the link below.');
                    $('#frm-request-owners').append('<h5><a href="/downloads/Aspects_owners_guide_Web.pdf" download="/downloads/Aspects_owners_guide_Web.pdf">Download owners guide (848k) &raquo;</a></h5>');
                    trackModalSuccess('property-owners');
                }
            }
        });
    });

    //AJAX REQUEST NEWSLETTER

    // render the reCAPTCHA
    $('.email-modal .subscriber-form input[type="text"]').bind('focus.recaptcha', function () {
        // only want to do this once!
        $('.email-modal .subscriber-form input[type="text"]').unbind('focus.recaptcha');
        // load the recaptcha button
        recaptcha.load('subscriber-form-recaptcha', function (token) {
            // once validated, set the token and enable the form
            $('.email-modal .subscriber-form input[name="token"]').val(token);
            $('.email-modal .subscriber-form input[type="submit"]').prop('disabled', false);
        });
    });

    $('.email-modal .subscriber-form').live('submit', function (event) {
        event.preventDefault();

        var formValues = $(this).serialize();

        $.ajax({
            url: '/ajax/request-newsletter',
            type: 'POST',
            data: {
                data: formValues
            },
            dataType: 'json',
            success: function (data) {
                $('.email-modal .subscriber-form').hide();
                if (data.error) {
                    $('.email-modal h3').after('<p class="error">There was a problem with your information: "' + data.msg + '".<br/>Please check and try again.</p>');
                } else {
                    $('.email-modal h3').after('<p class="sucess">Thanks for subscribing! Keep an eye out in your inbox for our next newsletter. :)</p>');
                    trackModalSuccess('newsletter-signup');
                    // reset the form, to keep it tidy.
                    $('.email-modal .subscriber-form input[type="text"]').val('');
                    $('.email-modal .subscriber-form input[name="token"]').val('');
                    $('.email-modal .subscriber-form input[type="submit"]').prop('disabled', true);
                }
                // success or not, we want to reset the captcha as subsequent requests would fail
                recaptcha.reset('subscriber-form-recaptcha');
            }
        });
    });


    //DOWNLOAD CONTENT FORM SUBMIT
    $('.details-required').live('click', function (event) {
        var name = $('#frm-request-brochure input#name').val();
        var email = $('#frm-request-brochure input#email').val();
        var modalType = getModalType();
        if (name == '' || email == '') {
            event.preventDefault();
            $('#register-wrap p').remove();
            $('#register-wrap').append('<p><small>Please complete your name and email address before you download.</small></p>')
        } else {
            event.preventDefault();
            $('#frm-request-brochure div').hide().after('<div class="spinny-wrapper"><img src="/images/ajax-loader.gif" /></div>');
            arr = $('#frm-request-brochure').serialize();

            var clickedLink = this;

            data = { data: arr, download: true };

            $.ajax({
                url: $('#frm-request-brochure').attr('action'),
                type: 'POST',
                data: data,
                dataType: 'json',
                success: function (data) {
                    $('.error').remove();

                    if (data.error) {
                        $('.spinny-wrapper').remove();
                        $('#frm-request-brochure div').show()
                        $('#frm-request-brochure h3').after('<p class="error">Name and Email are required to download.</p>');
                    } else {
                        $('.spinny-wrapper').remove();
                        $('#frm-request-brochure h3')
                            .empty().text('Thank you, your download will begin shortly.');
                        trackModalSuccess('download');
                        window.location = $(clickedLink).attr('href');
                    }
                }
            });

        }
    })

    var removeCount = 1;
    $('a.add-email').live('click', function (event) {
        event.preventDefault();
        removeCount++;
        $(this)
            .before('<input type="text" name="email_' + removeCount + '" id="email_' + removeCount + '"  class="email" />')
            .before('<a class="remove-email" rel="email_' + removeCount + '">- Remove</a>');
        $('#email_' + removeCount).focus();
    });

    $('a.remove-email').live('click', function (event) {
        inputId = $(this).attr('rel');
        $(this).remove();
        $('input#' + inputId).remove();
    });


    //WILLIES GOOGLE CLICKS
    $('#request-container a').click(function (event) {
        var link = $(this);
        if (link.parent().hasClass('booking')) {
            trackModalClick('booking');
        }
    });



    $('.add-guest').click(function (event) {
        event.preventDefault();

        holidayId = $(this).closest('fieldset[role="data-holiday-id"]').attr('data-holiday-id');
        $searchArea = $(this).closest('fieldset');
        $template = $searchArea.find('.guest-group:first-of-type').clone();
        partyCount = $searchArea.find('.guest-group').length;

        fieldId = $template.find('input').attr('id');
        fieldIdPrefix = fieldId.substr(0, fieldId.length - 1);

        $template.find('label[for="' + fieldId + '"]').attr('for', fieldIdPrefix + partyCount);
        $template.find('input').attr({
            id: fieldIdPrefix + partyCount,
            name: fieldIdPrefix + partyCount,
            value: ''
        });

        fieldId = $template.find('select').attr('id');
        fieldIdPrefix = fieldId.substr(0, fieldId.length - 1);

        $template.find('label[for="' + fieldId + '"]').attr('for', fieldIdPrefix + partyCount);;
        $template.find('select').attr({
            id: fieldIdPrefix + partyCount,
            name: fieldIdPrefix + partyCount
        });

        $template.insertAfter($searchArea.find('.guest-group:last'));

        $('div#' + holidayId + ' output.total-number-guest').html($searchArea.find('.guest-group').length);
    });

});

//FUNCTIONS AVAILABLE EVERYWHERE
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//MODAL WINDOW
export function modalWindow(content, noCloseIcon) {
    if (noCloseIcon == null) noCloseIcon = false;

    documentHeight = $(document).height();
    var mwindow = '<div id="overlay-container" style="height:' + documentHeight + 'px;"><div id="overlay-window">'
    if (!noCloseIcon) {
        mwindow += '<a href="#close" id="close-modal">Close x<span></span></a>'
    }
    mwindow += content + '</div></div>';

    var w = $(window).width(),
        t = $(window).height();

    $('body').append(mwindow);
    //POSITION THE LOGIN WINDOW
    $('#overlay-window').css({
        left: (w / 2) - ($('#overlay-window').outerWidth() / 2),
        top: $(window).scrollTop() + ((t / 2) - ($('#overlay-window').outerHeight() / 2))
    }).addClass("tint2");

    $('html').addClass('ModalOn');

    $(window).resize(function () {
        var w = $(window).width(),
            t = $(window).height();
        //POSITION THE LOGIN WINDOW
        $('#overlay-window').css({
            left: (w / 2) - ($('#overlay-window').width() / 2),
            top: $(window).scrollTop() + ((t / 2) - ($('#overlay-window').height() / 2))
        });
    })
    if (!noCloseIcon) {
        $('#close-modal').click(function (e) {
            e.preventDefault();
            $('#overlay-container').remove();
            $('html').removeClass('ModalOn');
        });
    }
}

var originalContent;
function modalWindowFromOnPageContent(elementId, noCloseIcon) {
    if (noCloseIcon == null) noCloseIcon = false;
    originalContent = $('#' + elementId);
    var contentForModal = originalContent.clone();
    originalContent.remove();
    modalWindow(contentForModal.html(), noCloseIcon);

    $('#close-modal').click(function () {
        $('#overlay-container').remove();
        $('body').append(originalContent);
    });
}
window.modalWindowFromOnPageContent = modalWindowFromOnPageContent;


////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//SLIDE FUNCTION
function slideUpDown(openclose, activeclass, classadd) {
    var state;

    classadd.toggleClass(activeclass);
    if (openclose.is(':visible')) {
        openclose.slideUp(300);
        state = 'up';
    } else {
        openclose.slideDown(200);
        state = 'down';

        $('html').addClass('ModalOn');

        $(window).resize(function () {
            var w = $(window).width(),
                t = $(window).height();
            //POSITION THE LOGIN WINDOW
            $('#overlay-window').css({
                left: (w / 2) - 135,
                top: $(window).scrollTop() + ((t / 2) - 175)
            });
        });
    }
    //TELLS US IF THE MAP IS OPEN OR CLOSED
    return state;
}

//QUICK FIX IN HERE CANT REMOVE URL FROM MODAL (modul-url)
function trackModalView(modalUrl) {
    switch (modalUrl) {
        case 'newsletter':
            break;

        case 'booking':
            break;

        case 'property-owners':
            break;

        case 'request':
            break;

        default:
            return;
    }
    var url = '/goal/' + modalUrl;
    dataLayerQueue.push({ 'event': 'pageView', 'virtualPageURL': url });
}

function trackModalClick(modalUrl) {
    trackModalEvent(modalUrl, 'click');
}

function trackModalSuccess(modalUrl) {
    trackModalEvent(modalUrl, 'form-success');
}

function trackModalDownload(modalUrl) {
    trackModalEvent(modalUrl, 'download');
}

function trackModalEvent(modalUrl, event) {
    var url = '/goal/' + modalUrl + '/' + event;
    dataLayerQueue.push({ 'event': 'pageView', 'virtualPageURL': url });
}

function getModalType() {
    var action = $('#overlay-window form').attr('action');

    if (action.indexOf("/ajax/testimonial") == 0) {
        action = "/ajax/testimonial";
    }

    switch (action) {
        case '/ajax/request-brochure':
            return 'request';
            break;
        case '/ajax/request-owners':
            return 'property-owners';
            break;
        case 'http://newsletter.nixondesign.com/t/r/s/auijii/':
            return 'newsletter';
            break;
        case '/ajax/testimonial':
            return 'property-testimonial';
            break;
    }
    return false;
}

$(function () {
    function reservationSharePopup(url) {
        var winWidth, winHeight, winLeft, winTop;

        winWidth = 550;
        winHeight = 350;
        winLeft = (screen.width - winWidth) / 2;
        winTop = (screen.height - winHeight) / 2;

        window.open(url, "Share", "width=" + winWidth + ",height=" + winHeight + ",left=" + winLeft + ",top=" + winTop)
    }

    function trackReservationShare(method, url) {
        dataLayerQueue.push({ 'event': 'reservationShare', 'shareMethod': method, 'shareURL': url });
    }

    function tweetLength($container) {
        var urlLen = 22;
        var viaLen = ("via @AspectsHolidays").length;

        var remainingCharacters = 140 - ($('.res-share-tweet', $container).val().length + urlLen + viaLen + 2);
        var $display = $('.res-share-tweetlen', $container);
        $display.text(remainingCharacters);

        if (remainingCharacters < 0)
            $display.css('color', 'red');
        else
            $display.css('color', '#999');
    }


    $('.res-share-container .res-share-nav ul li').click(function () {
        var rel = $(this).attr('rel');
        console.log('.res-share-tabs>div.' + rel);
        var $container = $(this).parents('.res-share-container');

        $(this).siblings().removeClass('active');
        $(this).addClass('active');

        $container.find('.res-share-tabs>div.active').removeClass('active');
        $container.find('.res-share-tabs>div.' + rel).addClass('active');
    });


    //FACEBOOK
    $(".res-share-container .facebook .res-share-button").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $container = $(this).parents('.res-share-container');
        var facebookUrl = 'http://www.facebook.com/sharer.php?u=' + $container.attr('data-shareUrl');
        reservationSharePopup(facebookUrl);
        trackReservationShare('Facebook', facebookUrl);
    });



    $(".res-share-container").each(function () {
        tweetLength($(this));
    });

    $(".res-share-container .res-share-tweet").on('keyup', function () {
        tweetLength($(this).parents('.res-share-container'));
    });

    $(".res-share-container .twitter .res-share-button").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $container = $(this).parents('.res-share-container');
        var url = $container.attr('data-shareUrl');
        var tweet = $('.res-share-tabs .twitter .res-share-tweet', $container).val();

        var twitterUrl = "http://twitter.com/share?text=" + tweet + "&url=" + url + "&via=AspectsHolidays";

        reservationSharePopup(twitterUrl);

        trackReservationShare('Twitter', url);
    });

    $(".res-share-container .email .res-share-button").click(function (e) {
        e.preventDefault();
        e.stopPropagation();

        var $container = $(this).parents('.res-share-container');
        var $div = $('.res-share-tabs .email', $container);
        var $form = $div.find("select, textarea, input");
        var data = $form.serialize();

        $.ajax({
            url: '/ajax/emailReservationShare.aspx',
            method: 'POST',
            data: data,
            dataType: 'json',
            success: function (res) {
                if (res.error == false) {
                    $div.empty();
                    $div.html("<h3>Thank you, your email was sent successfully!</h3>");

                    trackReservationShare('Email', $container.attr('data-shareUrl'));
                }
                else {
                    modalWindow('<div><h3>Error sending email</h3><p style="color:red">' + res.error + '</p>');
                }
            }
        })
    });
});